import { Component, OnInit } from '@angular/core';
import { FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { Empty_LetterRequestCustomer_Schedule_Interface, LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { LetterRequestCustomerScheduleServiceService } from 'src/app/Service/Letter/LetterRequestCustomerScheduleService.service';

import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ScheduleLetterModirList',
  templateUrl: './ScheduleLetterModirList.component.html',
  styleUrls: ['./ScheduleLetterModirList.component.css']
})
export class ScheduleLetterModirListComponent implements OnInit {
  Filter_title:string=""
  Filter_customerName:string=""
  Filter_letterCode:string=""
  BaseUrl1:string=""
  BaseUrlCo:string="&id2="
  page:number=0;
  Procssing:boolean=false


  FormTypeShow:string='List'
  
  modalRef_Delete: any;

  constructor(
    private FlowcharPaper_Service:FlowcharPaperService,
    private LetterRequestCustomerSchedule_Service:LetterRequestCustomerScheduleServiceService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }


  DataList_Schedule:Array<LetterRequestCustomer_Schedule_Interface>=[]
  DataList_History:Array<FlowchartPaper_History_Interface>=[]
  Selected_Schedule_Record:  LetterRequestCustomer_Schedule_Interface=Empty_LetterRequestCustomer_Schedule_Interface();

  ngOnInit() {
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/WorkflowDetail?id="
    this.Nav_Service.CheckValidPage(2211).subscribe(
      data=>{
        this.ReadData_Schedule()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    
  }

  ReadData_Schedule(){
    this.Procssing=true
    this.LetterRequestCustomerSchedule_Service.GetModir().subscribe(
      data=>{

        this.DataList_Schedule=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }


  
  ReadData_History(item:LetterRequestCustomer_Schedule_Interface){
    this.Procssing=true
    this.FlowcharPaper_Service.History_WorkFlow(item.flowchart.makerId).subscribe(
      data=>{

        this.Selected_Schedule_Record=item
        this.DataList_History=data
        this.FormTypeShow='History'
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ReadData_Form(item:LetterRequestCustomer_Schedule_Interface){
    item.sms=!item.sms
  }

  ReadData_View(item:LetterRequestCustomer_Schedule_Interface){
    this.Selected_Schedule_Record=item

    this.FormTypeShow='View'
  }

  Close_Show_History(){
    this.Selected_Schedule_Record=Empty_LetterRequestCustomer_Schedule_Interface()
    this.FormTypeShow='List'
  }

}
